import React from 'react';
import '../style/layout.css'; // Shared styles for pages

const Layout = ({ children, className = '' }) => {
  return <div className={`layout ${className}`}>{children}</div>;
};

export default Layout;